// extracted by mini-css-extract-plugin
module.exports = {"container":"Wntfgncz3tmVStnylfDSP","subCategoriesList":"_1fSmC_j-M8Dvl6h4-Xz223","item":"_5MBbB_i3zyvk3E0aZTAsr","dot":"_2vdRwfzWanVNH_hm2GtcLr","input":"_1sk2xRJuTemJ_YF_L1eDgZ"};